import React, {useEffect, useState} from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HomeCarousel from './components/HomeCarousel';
import About from './components/About';
import Services from './components/Services';
import Careers from './components/Careers';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Industry from './components/Industry';
import Admin from './components/Admin';

function App(){
  const [isAdmin, setIsAdmin] = useState(() => window.location.hash === '#admin');

  useEffect(() => {
    const handleHashChange = () => setIsAdmin(window.location.hash === '#admin');
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (isAdmin) return <Admin />;

  return (
    <div className="zm-root" id="home">
      <Header />
      <main>
        <Hero />
        <HomeCarousel />
        <About />
        <Industry/>
        <Services />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App;
